var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2933 61C25.2718 61 25.6346 60.2241 24.909 58.3103L19 38.8621L55.6978 16L60 17.1379L56.4235 26.8621L27.2933 61Z",
    fill: "#C8DAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 61C29.5 61 30.15 60.2837 31 59.4651C32.3 58.186 49 41.5581 49 41.5581L38.75 39L29.25 45.1395L28 60.4884V61Z",
    fill: "#A9C9DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6095 45.2913L53.8259 64.2162C56.6915 65.8066 58.7755 65.0114 59.5049 61.5127L69.7686 12.3183C70.8106 8.02442 68.1535 6.11603 65.3922 7.38829L5.16436 31.0313C1.04844 32.7276 1.10054 35.0601 4.43495 36.0673L19.9087 40.9974L55.7016 18.0435C57.3688 16.9833 58.9318 17.5664 57.6814 18.7327L28.6095 45.2913Z",
    fill: "url(#paint0_linear_3153_131878)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3153_131878",
    x1: 43.7138,
    y1: 34.3471,
    x2: 57.066,
    y2: 55.3435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramWhite);
export default __webpack_public_path__ + "static/media/telegram-white.e5c7735e57bb286a056274e0396897bb.svg";
export { ForwardRef as ReactComponent };